import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import SiteFooter, { COMPANY_ADDRESS } from "@/components/SiteFooter";
import { ArrowLeft, ReceiptText, Ban, Clock, Mail } from "lucide-react";

const EFFECTIVE_DATE = "June 2026";
const REFUND_EMAIL = "hello@cinevoya.com";

const Section = ({ icon: Icon, title, children, testId }) => (
  <section className="mt-10" data-testid={testId}>
    <h2 className="font-display text-lg md:text-lg font-bold flex items-center gap-2 mb-3">
      <Icon className="w-5 h-5 text-terracotta" /> {title}
    </h2>
    <div className="text-sm text-foreground/75 leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-ink grain">
      <Navbar />
      <div className="pt-28 px-6 sm:px-12 lg:px-20 max-w-3xl mx-auto pb-16" data-testid="refund-policy-page">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-terracotta hover:text-ember mb-6" data-testid="refund-back-link">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to home
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <ReceiptText className="w-6 h-6 text-gold" />
          <p className="text-xs uppercase tracking-widest text-terracotta font-semibold">Legal · Refunds</p>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black mb-3">Refund Policy</h1>
        <p className="text-foreground/55 text-sm">Effective {EFFECTIVE_DATE}</p>

        <Section icon={Ban} title="Digital purchases are non-refundable" testId="refund-section-nonrefundable">
          <p>
            All digital content purchases on Cinevoya — including <strong>film rentals</strong>,{" "}
            <strong>Watch Party access</strong> and <strong>donations</strong> — are non-refundable once the
            content has been accessed or streamed.
          </p>
        </Section>

        <Section icon={Clock} title="Technical faults: 24-hour window" testId="refund-section-technical">
          <p>
            If you were unable to access content you paid for because of a technical fault on the Cinevoya
            platform, a refund may be considered when requested within <strong>24 hours</strong> of purchase,
            provided the content was not accessed.
          </p>
        </Section>

        <Section icon={Mail} title="How to request a refund" testId="refund-section-contact">
          <p>Send your refund request, including your account email, the film title and the date of purchase, to:</p>
          <div className="mt-3 p-5 rounded-xl border border-terracotta/30 bg-terracotta/5">
            <a href={`mailto:${REFUND_EMAIL}`} className="font-display text-xl font-bold text-foreground hover:text-terracotta transition-colors" data-testid="refund-contact-email">
              {REFUND_EMAIL}
            </a>
            <p className="text-xs text-foreground/50 mt-2">Cinevoya · {COMPANY_ADDRESS}</p>
          </div>
        </Section>
      </div>
      <SiteFooter tagline="Curated African short cinema." maxWidth="max-w-3xl" />
    </div>
  );
}
